
const apiConfig = {
    //Local
    //apiUrl: 'https://localhost:7169/api/',
    //Live

    //DEV
    apiUrl: 'https://sf-api.solegaze.com/api/',

    // Demo
    //apiUrl: 'https://demo-api.solegaze.com/api/',

    apiKey: 'Lieda1002',
};

export default apiConfig;

